(function () {
    angular.module('tradersyard').component('tyReportCommonModal', {
        bindings: {
            resolve: '<',
            close: '&',
            modalInstance: '<',
        },
        controller: 'ReportModalCtrl',
        // language=HTML
        template: `
            <div class="modal-header" ng-switch on="entityInfo.entryName">
                <h2 ng-switch-when="post">Report post</h2>
                <h2 ng-switch-default>Report "<span ng-bind="entityInfo.entryModel.name"></span>"</h2>
            </div>
            <div class="modal-body">
                <form ng-submit="$ctrl.submit()">
                    <p style="padding: 3px 0">
                        <input type="radio" ng-model="formData.reason"
                               value="illegal-content"> Illegal content
                    </p>
                    <p style="padding: 3px 0">
                        <input type="radio" ng-model="formData.reason" value="spam"> Spam
                    </p>
                    <p style="padding: 3px 0">
                        <input type="radio" ng-model="formData.reason" value=""> Other
                    </p>
                    <span ng-bind="errors.reason"></span>

                    <div ng-show="formData.reason === ''">
                        <textarea ng-model="formData.message" placeholder="Message..."
                                  style="margin: 20px 0 0"></textarea>
                    </div>
                    <span ng-bind="errors.message"></span>

                    <div style="margin: 20px 0 0">
                        <button type="submit">Report</button>
                        <a class="button" ng-click="$ctrl.close()">Close</a>
                    </div>
                </form>
            </div>
        `,
    });
})();
